import React from "react";
import old from "./Img/datalist/betteroldengagement.webp"
import perfect from "./Img/datalist/perfect.webp"
import care from "./Img/datalist/care.webp"
import progress from "./Img/datalist/progress.webp"
import oneForAll from "./Img/datalist/oneForAll.webp"

export const Data = [
  {
    image: oneForAll,
    content: [ <>
      <p className="heading1 fw-bold ufs-11 m-0 p-0 ">One Device infinite</p>
      <p className="heading2 fw-bold ufs-13 m-0 p-0 text-blue lh-sm ">
        POSSIBILITIES...
      </p>
      <ul className="custom-list text-start fw-bold ufs-6 m-0 upx-5 upy-7 ">
        <li className="m-0 p-0 ">Reach exercise games</li>
        <li className="m-0 p-0">Balance and pre-gait exercise</li>
        <li className="m-0 p-0">Fine motor training</li>
        <li className="m-0 p-0">Muscle strengthening, & lot more...</li>
      </ul>
    </>],
    flexReverse: false,
  },
  {
    image: perfect,
    content: [<>
      <p className="heading1 fw-bold ufs-13 m-0 p-0 lh-sm">Perfect <span style={{color:"#33b3a6"}} >FORM</span></p>
      <p className="heading2 fw-bold ufs-13 m-0 p-0 lh-sm">Perfect <span style={{color:"#33b3a6"}} >RESULTS</span> </p>
      <ul className="custom-list text-start fw-bold ufs-6 m-0 upx-5 upt-7 ">
        <li className="m-0 p-0 ">The games ensure</li>
        <li className="m-0 p-0">Good form of motion</li>
        <li className="m-0 p-0">Quality of repetitions</li>
        <li className="m-0 p-0">Better functional exercises</li>
      </ul>
      <p className="fw-bold ufs-6 m-0 p-0 text-blue">-Speeds up recovery</p>
    </>],
    flexReverse: true,
  },
  {
    image: old,
    content:[<>
      <p className="heading1 fw-bold ufs-11 m-0 p-0 ">Therapy made</p>
      <p className="heading2 fw-bold ufs-13 m-0 p-0 text-blue lh-sm">EXCITING!</p>
      <p className="para fw-bold ufs-6 m-0 p-0 upt-7">Transforming boring exercises of mid & late-stage rehabilitation into engaging experiences.</p>
      <ul className="custom-list text-start fw-bold ufs-6 m-0 upx-5 upy-3 ">
        <li className="m-0 p-0 ">Enhances retention</li>
        <li className="m-0 p-0">Motivates to continue therapy</li>
        <li className="m-0 p-0">Help achieve complete recovery</li>
      </ul>
    </>],
    flexReverse: false,
  },
  {
    image: care,
    content: [<>
      <p className="heading1 fw-bold ufs-11 m-0 p-0 "> Better Cares for</p>
      <p className="heading2 fw-bold ufs-13 m-0 p-0 text-blue lh-sm">YOU</p>
      <p className="para fw-bold ufs-6 m-0  upy-7">While you Patients do <span style={{color:"#33b3a6"}} >NEXT LEVEL</span> therapy, Better <span style={{color:"#33b3a6"}} >saves your energy</span> by eliminating menial tasks.</p>
      </>],
    flexReverse: true,
  },
  {
    image: progress ,
    content: [<>
      <p className="heading1 fw-bold ufs-13 m-0 p-0 lh-sm "><span style={{color:"#33b3a6"}} >PROGRESS</span></p>
      <p className="heading2 fw-bold ufs-11 m-0 p-0 lh-sm">that motivates &</p>
      <p className="heading2 fw-bold ufs-11 m-0 p-0 lh-sm "> reinforces <span style={{color:"#33b3a6"}}>TRUST</span></p>
      <p className="para fw-bold ufs-6 m-0  upt-7 "><span style={{color:"#33b3a6"}} > Visual insights</span> of progress are represented in simplified  form  that  even <span style={{color:"#33b3a6"}} > patients can understand.</span> Helps better communication, motivation, and reinforces <span style={{color:"#33b3a6"}} >trust in therapy.</span></p>
      </>],
    flexReverse: false,
  },
];



export const Datas = [
  {
    image: oneForAll,
    content: [ <>
      <p className="heading1 fw-bold ufs-12 m-0 p-0 ">One Device infinite</p>
      <p className="heading2 fw-bold ufs-14 m-0 p-0 text-blue lh-sm ">
        POSSIBILITIES...
      </p>
      <ul className="custom-list text-start fw-bold ufs-13 m-0 upx-5 upy-7 ">
        <li className="m-0 p-0 ">Reach exercise games</li>
        <li className="m-0 p-0">Balance and pre-gait exercise</li>
        <li className="m-0 p-0">Fine motor training</li>
        <li className="m-0 p-0">Muscle strengthening, & lot more...</li>
      </ul>
    </>],
   
  },
  {
    image: perfect,
    content: [<>
      <p className="heading1 fw-bold ufs-14 m-0 p-0 lh-sm">Perfect <span style={{color:"#33b3a6"}} >FORM</span></p>
      <p className="heading2 fw-bold ufs-14 m-0 p-0 lh-sm">Perfect <span style={{color:"#33b3a6"}} >RESULTS</span> </p>
      <ul className="custom-list text-start fw-bold ufs-13 m-0 upx-5 upt-7 ">
        <li className="m-0 p-0 ">The games ensure</li>
        <li className="m-0 p-0">Good form of motion</li>
        <li className="m-0 p-0">Quality of repetitions</li>
        <li className="m-0 p-0">Better functional exercises</li>
      </ul>
      <p className="fw-bold ufs-13 m-0 p-0 text-blue">-Speeds up recovery</p>
    </>],
 
  },
  {
    image: old,
    content:[<>
      <p className="heading1 fw-bold ufs-12 m-0 p-0 ">Therapy made</p>
      <p className="heading2 fw-bold ufs-14 m-0 p-0 text-blue lh-sm">EXCITING!</p>
      <p className="para fw-bold ufs-13 m-0 p-0 upt-7">Transforming boring exercises of mid & late-stage rehabilitation into engaging experiences.</p>
      <ul className="custom-list text-start fw-bold ufs-13 m-0 upx-5 upy-3 ">
        <li className="m-0 p-0 ">Enhances retention</li>
        <li className="m-0 p-0">Motivates to continue therapy</li>
        <li className="m-0 p-0">Help achieve complete recovery</li>
      </ul>
    </>],
    
  },
  {
    image: care,
    content: [<>
      <p className="heading1 fw-bold ufs-12 m-0 p-0 "> Better Cares for</p>
      <p className="heading2 fw-bold ufs-14 m-0 p-0 text-blue lh-sm">YOU</p>
      <p className="para fw-bold ufs-13 m-0  upy-7">While you Patients do <span style={{color:"#33b3a6"}} >NEXT LEVEL</span> therapy, Better <span style={{color:"#33b3a6"}} >saves your energy</span> by eliminating menial tasks.</p>
      </>],
    
  },
  {
    image: progress ,
    content: [<>
      <p className="heading1 fw-bold ufs-14 m-0 p-0 lh-sm "><span style={{color:"#33b3a6"}} >PROGRESS</span></p>
      <p className="heading2 fw-bold ufs-12 m-0 p-0 lh-sm">that motivates &</p>
      <p className="heading2 fw-bold ufs-12 m-0 p-0 lh-sm "> reinforces <span style={{color:"#33b3a6"}}>TRUST</span></p>
      <p className="para fw-bold ufs-13 m-0  upt-7 "><span style={{color:"#33b3a6"}} > Visual insights</span> of progress are represented in simplified  form  that  even <span style={{color:"#33b3a6"}} > patients can understand.</span> Helps better communication, motivation, and reinforces <span style={{color:"#33b3a6"}} >trust in therapy.</span></p>
      </>],
  
  },
];


